import { DatePicker } from "@mui/lab";
import {
  AlertColor,
  Autocomplete,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  IconButton,
  InputAdornment,
  MenuItem,
  Modal,
  TextField,
  Theme,
  Typography,
  useMediaQuery,
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { globalTheme } from "../../../common/theme";
import createStyles from "@mui/styles/createStyles";
import axios, { AxiosResponse } from "axios";
import React, { useImperativeHandle, useMemo } from "react";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import { Invoice, InvoiceItem } from "./InvoiceAccessories";
import { DropDownComboOption } from "../../component/GenericFilter";
import { SnackBarMessage, SnackBarMessageProps } from "../../component/SnackBarMessage";
import { GeneralDialog } from "../../component/GeneralDialog";
import Title from "../../component/Title";
import { CustomDropDown3 } from "../../component/CustomDropDown3";
import { defaultBankName, defaultBankNameSS, defaultBankNameTH, defaultInvoiceRegions, defaultPaymentTerm, GetCustLangIdsByLanguageId, Languages } from "../../../common/Constants";
import moment from "moment";
import { CommonProps } from "../../component/MainContents";
import { CustomDropDown1 } from "../../component/CustomDropDown1";
import { DataGridPro } from "@mui/x-data-grid-pro";
import { GridCellParams, GridColumns, GridPreProcessEditCellProps, GridRenderCellParams, GridRowId, GridToolbarContainer, GridValueSetterParams } from "@mui/x-data-grid";
import { CustomTablePagination } from "../../component/CustomPagination";
import { Add, Clear, ContentCopy, Delete, Info, Search } from "@mui/icons-material";
import { FormatNumber, Pad } from "../../../common/Formatter";
import { ProductList, ProductListHandle } from "../products/ProductList";
import { ProductListItem } from "../products/ProductAccessories";
import { Customer, CustomerAddressItem, CustomerContactPersonItem } from "../customers/CustomerAccessories";
import { GetNoOfLines, HasDuplicates, ValidateNumber } from "../../../common/CommonFunctions";
import { InvoiceViewer, InvoiceViewerHandle } from "./InvoiceViewer";
import { BranchInfo } from "../branches/BranchAccessories";
import { EndUserList, EndUserListHandle } from "../end-users/EndUserList";
import { EndUserListItem } from "../end-users/EndUserAccessories";
import { Bank, BankAccount } from "../banks/BankAccessories";
import { renewToken } from "../../../services/AuthService";
import { NumberTypes } from "../../../models/enums/NumberType";
import { CustomerAddress, CustomerAddressHandle } from "../customers/CustomerAddress";
import { CustomerContactPerson, CustomerContactPersonHandle } from "../customers/CustomerContactPerson";
import NumberFormat from "react-number-format";
import { OpenMode } from "../../../common/Enums";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
  })
);

export interface InvoiceSingleHandle {
  Initialise: (mode: OpenMode, invoice: Invoice, isProforma: boolean) => void;
}

export function GetInvoiceRegion(invoiceNo: string) {
  return invoiceNo.substring(2, 4);
}

export const InvoiceSingle = React.forwardRef(
  (props: CommonProps, ref: React.Ref<InvoiceSingleHandle>) => {
    const style = { ...useStyles(), ...globalTheme() };

    const tinyScreen = useMediaQuery('(max-width:1366px)');
    const smallScreen = useMediaQuery('(max-width:1920px)');
    const normalScreen = useMediaQuery('(max-width:2560px)');

    const [hasError, setHasError] = React.useState(false);

    const singleModalRef = React.useRef<ProductListHandle>(null);
    const endUserListModalRef = React.useRef<EndUserListHandle>(null);
    const viewerModalRef = React.useRef<InvoiceViewerHandle>(null);
    const customerAddressModalRef = React.useRef<CustomerAddressHandle>(null);
    const customerContactPersonModalRef = React.useRef<CustomerContactPersonHandle>(null);

    const [open, setOpen] = React.useState(false);
    const [openMode, setOpenMode] = React.useState<OpenMode>(OpenMode.NEW);
    const [model, setModel] = React.useState<Invoice>();
    const [loading, setLoading] = React.useState<boolean>(false);
    const [region, setRegion] = React.useState<string>("");
    const [filteredCustomers, setFilteredCustomers] = React.useState<DropDownComboOption[]>([]);
    const [currentEndUserRow, setCurrentEndUserRow] = React.useState<number>();
    const [invoiceTotal, setInvoiceTotal] = React.useState<number>(0);
    const [nextMonthChecked, setNextMonthChecked] = React.useState<boolean>(false);
    const [nextMonthDisabled, setNextMonthDisabled] = React.useState<boolean>(false);
    const [showEndUser, setShowEndUser] = React.useState<boolean>(true);
    const [copyEndUser, setCopyEndUser] = React.useState<string>("");
    const [copyEndUserId, setCopyEndUserId] = React.useState<number>(0);

    const [disableRegionDropDown, setDisableRegionDropDown] = React.useState<boolean>(true);
    const [disablePreviewButton, setDisablePreviewButton] = React.useState<boolean>(true);
    const [proformaInvoicePrefix, setProformaInvoicePrefix] = React.useState<string>("");

    const [branchInfo, setBranchInfo] = React.useState<BranchInfo[]>([]);

    const [selectedCustomer, setSelectedCustomer] = React.useState<Customer>();

    const [banks, setBanks] = React.useState<Bank[]>([]);
    const [allBanks, setAllBanks] = React.useState<Bank[]>([]);
    const [bankAccounts, setBankAccounts] = React.useState<BankAccount[]>([]);
    const [allBankAccounts, setAllBankAccounts] = React.useState<BankAccount[]>([]);
    const [selectedBankId, setSelectedBankId] = React.useState<number>(0);
    const [selectedBankAccountId, setSelectedBankAccountId] = React.useState<number>(0);

    const [lessAmountErrorText, setLessAmountErrorText] = React.useState<string>("");
    const [lessPercentErrorText, setLessPercentErrorText] = React.useState<string>("");

    const [invoiceRegions, setInvoiceRegions] = React.useState<DropDownComboOption[]>([]);

    const [switchPageOnClose, setSwitchPageOnClose] = React.useState<boolean>(false);
    const [saved, setSaved] = React.useState<boolean>(false);
    const [currency, setCurrency] = React.useState<string>("");

    const [showPoNo, setShowPoNo] = React.useState<string>('hidden');
    const [selectedItem, setSelectedItem] = React.useState<InvoiceItem | null>(null);

    function getBankId(bankName: string) {
      if (bankName == "")
        return 0;

      return banks.find(x => x.bankName == bankName)?.bankID ?? 0;
    }

    const accountsByBank = useMemo(()=> filterAccounts(selectedBankId), [selectedBankId]);
    function filterAccounts(id: number) {
      if (id == 0)
        return bankAccounts;

      return bankAccounts.filter(function (acc) {
        return acc.bankID == id;
      });
    }

    const bankAccount = useMemo(() => getBankAccount(selectedBankAccountId), [selectedBankAccountId]);
    function getBankAccount(id: number) {
      if (id == 0)
        return "";

      let acc = bankAccounts.find(x => x.bankAccountID == id);

      return acc?.bankAccountNumber;
    }

    function getBankAccountId(accountNumber: string) {
      if (accountNumber == "")
        return 0;

      return bankAccounts.find(x => x.bankAccountNumber == accountNumber)?.bankAccountID ?? 0;
    }

    const bankAddress = useMemo(() => getBankAddress(selectedBankId), [selectedBankId]);
    function getBankAddress(id: number) {
      if (id == 0)
        return "";

      return banks.find(x => x.bankID == id)?.bankAddress;
    }

    const [selectionModel, setSelectionModel] = React.useState<GridRowId[]>([]);

    const [gridData, setGridData] = React.useState<InvoiceItem[]>([]);

    const columnWidth25 = useMemo(() => GetColumnWidth(25, tinyScreen, smallScreen), [tinyScreen, smallScreen]);
    const columnWidth35 = useMemo(() => GetColumnWidth(35, tinyScreen, smallScreen), [tinyScreen, smallScreen]);
    const columnWidth40 = useMemo(() => GetColumnWidth(40, tinyScreen, smallScreen), [tinyScreen, smallScreen]);
    const columnWidth50 = useMemo(() => GetColumnWidth(50, tinyScreen, smallScreen), [tinyScreen, smallScreen]);
    const columnWidth55 = useMemo(() => GetColumnWidth(55, tinyScreen, smallScreen), [tinyScreen, smallScreen]);
    const columnWidth60 = useMemo(() => GetColumnWidth(60, tinyScreen, smallScreen), [tinyScreen, smallScreen]);
    const columnWidth68 = useMemo(() => GetColumnWidth(68, tinyScreen, smallScreen), [tinyScreen, smallScreen]);
    const columnWidth70 = useMemo(() => GetColumnWidth(70, tinyScreen, smallScreen), [tinyScreen, smallScreen]);
    const columnWidth80 = useMemo(() => GetColumnWidth(80, tinyScreen, smallScreen), [tinyScreen, smallScreen]);
    const columnWidth100 = useMemo(() => GetColumnWidth(100, tinyScreen, smallScreen), [tinyScreen, smallScreen]);
    const columnWidth120 = useMemo(() => GetColumnWidth(120, tinyScreen, smallScreen), [tinyScreen, smallScreen]);
    const columnWidth140 = useMemo(() => GetColumnWidth(160, tinyScreen, smallScreen), [tinyScreen, smallScreen]);
    function GetColumnWidth(width: number, isTiny: boolean, isSmall: boolean) {
      switch (width) {
        case 25:
          return isTiny ? 25 : (isSmall ? 30 : 35);
        case 35:
          return isTiny ? 35 : (isSmall ? 40 : 45);
        case 40:
          return isTiny ? 40 : (isSmall ? 45 : 55);
        case 50:
          return isTiny ? 50 : (isSmall ? 58 : 68);
        case 55:
          return isTiny ? 55 : (isSmall ? 70 : 80);
        case 60:
          return isTiny ? 60 : (isSmall ? 80 : 90);
        case 68:
          return isTiny ? 68 : (isSmall ? 85 : 100);
        case 70:
          return isTiny ? 70 : (isSmall ? 90 : 105);
        case 80:
          return isTiny ? 80 : (isSmall ? 100 : 110);
        case 100:
          return isTiny ? 100 : (isSmall ? 125 : 150);
        case 120:
          return isTiny ? 120 : (isSmall ? 155 : 190);
        case 160:
          return isTiny ? 160 : (isSmall ? 210 : 270);
        default:
          return width;
      }
    }

    //Grid columns
    const columns: GridColumns = [
      {
        field: 'seq', headerName: 'No.', disableColumnMenu: true, 
        width: columnWidth40, minWidth: columnWidth40, 
        type: 'number', editable: true, align: 'right',
        valueSetter: (param: GridValueSetterParams) => onSeqChanged(param),
        preProcessEditCellProps: validateSeqChanged,
        cellClassName: style.NumberTextField
      },
      { field: 'model', headerName: '型式', width: columnWidth140, minWidth: columnWidth140, type: 'string' },
      { 
        field: 'osQty', headerName: '採購数量', disableColumnMenu: true, sortable: false, 
        width: columnWidth60, minWidth: columnWidth60, type: 'number', editable: false, 
        cellClassName: style.NumberTextField
      },
      {
        field: 'qty', headerName: '数量', disableColumnMenu: true, sortable: false, 
        width: columnWidth50, minWidth: columnWidth50, 
        type: 'number', editable: true,
        valueSetter: onQtyChanged,
        preProcessEditCellProps: validateQtyChanged,
        cellClassName: style.NumberTextField
      },
      {
        field: 'euPrice', headerName: 'EU Price', disableColumnMenu: true, sortable: false, 
        width: columnWidth70, minWidth: columnWidth70, 
        type: 'number', editable: true,
        valueFormatter: (param) => FormatNumber(param.value, 2),
        valueSetter: onEuPriceChanged,
        preProcessEditCellProps: validateNumberValueChanged,
        cellClassName: style.NumberTextField
      },
      {
        field: 'cartonNo', headerName: 'C/No.', flex: 1.5, type: 'string', editable: true,
        valueSetter: (param: GridValueSetterParams) => onCellValueChanged(param, "cartonNo", 10)
      },
      {
        field: 'partNo', headerName: 'Part No.', flex: 1.5, type: 'string', editable: true,
        valueSetter: (param: GridValueSetterParams) => onCellValueChanged(param, "partNo", 20)
      },
      {
        field: 'clientPO', headerName: 'Client PO', flex: 2, type: 'string', editable: true,
        valueSetter: (param: GridValueSetterParams) => onCellValueChanged(param, "clientPO", 30)
      },
      {
        field: 'productDesc', headerName: '製品名', flex: 6, type: 'string', minWidth: 100, editable: true,
        valueSetter: (param: GridValueSetterParams) => onCellValueChanged(param, "productDesc", 80),
      },
      {
        field: 'customerPartNo', headerName: 'Customer Part No.', flex: 2.8, type: 'string', editable: true,
        valueSetter: (param: GridValueSetterParams) => onCellValueChanged(param, "customerPartNo", 20)
      },
      {
        field: 'endUser', headerName: 'End User', disableColumnMenu: true, sortable: false,
        flex: 3.8,
        type: 'string', editable: true,
        valueSetter: onEndUserChanged,
        preProcessEditCellProps: validateEndUserChanged
      },
      {
        field: 'serialNo', headerName: 'Serial No', flex: 2.5, type: 'string', editable: true,
        valueSetter: (param: GridValueSetterParams) => onCellValueChanged(param, "serialNo", 50)
      },
      { field: 'unit', headerName: '单位', disableColumnMenu: true, sortable: false, width: columnWidth40, minWidth: columnWidth40, type: 'string' },
      { field: 'description', headerName: '針長', flex: 3, type: 'string' }
    ];

    const [searchData, setSearchData] = React.useState<any>({
      pageSize: 10,
    });

    const selectedData = React.useRef<InvoiceItem[]>([]);

    function onCellValueChanged(param: GridValueSetterParams, field: string, maxLength: number) {
      renewToken();
      let row: InvoiceItem = param.row;
      Object.entries(row).forEach(([key, value]) => {
        if (`${key}` === field)
        {
          if (maxLength > 0)
            Reflect.set(row, key, param.value.slice(0,maxLength));
          else
            Reflect.set(row, key, param.value);
        }
      });

      let tmpData = gridData;
      let index = tmpData.findIndex(x => x.id === row.id);
      Object.entries(tmpData[index]).forEach(([key, value]) => {
        if (`${key}` === `${field}`)
        {
          if (maxLength > 0)
            Reflect.set(tmpData[index], key, param.value.slice(0,maxLength));
          else
            Reflect.set(tmpData[index], key, param.value);
        }
      });
      setGridData(tmpData);

      hasChanges.current = true;
      return { ...param.row, row };
    }

    function onQtyChanged(param: GridValueSetterParams) {
      let row: InvoiceItem = param.row;
      let tmpData = gridData;
      let index = tmpData.findIndex(x => x.id === row.id);
      setInvoiceTotal(invoiceTotal - tmpData[index].euPrice * tmpData[index].qty + tmpData[index].euPrice * parseInt(param.value.toString()))
      if (tmpData[index].poNo==="")
      {
        row.osQty = parseInt(param.value.toString());
        row.qty = parseInt(param.value.toString());
        tmpData[index].osQty = parseInt(param.value.toString());
        tmpData[index].qty = parseInt(param.value.toString());
      }
      else
      {
        if (parseInt(param.value.toString()) > tmpData[index].osQty)
        {
          row.qty = tmpData[index].osQty;
          tmpData[index].qty = tmpData[index].osQty;
        }
        else
        {
          row.qty = parseInt(param.value.toString());
          tmpData[index].qty = parseInt(param.value.toString());
        }
      }
      tmpData[index].qty = parseInt(param.value.toString());
        
      setGridData(tmpData);

      hasChanges.current = true;
      return { ...param.row, row };
    }

    function onEuPriceChanged(param: GridValueSetterParams) {
      let row: InvoiceItem = param.row;
      let tmpData = gridData;
      let index = tmpData.findIndex(x => x.id === row.id);
      setInvoiceTotal(invoiceTotal - tmpData[index].euPrice * tmpData[index].qty + parseFloat(param.value.toString()) * tmpData[index].qty)
      row.euPrice = parseFloat(param.value.toString());
      tmpData[index].euPrice = parseFloat(param.value.toString());
      setGridData(tmpData);

      hasChanges.current = true;
      return { ...param.row, row };
    }

    function onEndUserChanged(param: GridValueSetterParams) {
      let row: InvoiceItem = param.row;
      let rowIndex = props.endUsers.findIndex(x => x.endUserName.trim() === param.value || x.endUserEng.trim() === param.value);
      if (param.value == '')
      {
        row.endUser = param.value;
        row.endUserID = 0;
      }
      else
      {
        row.endUser = param.value;
        row.endUserID = props.endUsers[rowIndex].endUserId;

        let tmpData = gridData;
        let index = tmpData.findIndex(x => x.id === row.id);
        tmpData[index].endUser = row.endUser;
        tmpData[index].endUserID = row.endUserID;
        setGridData(tmpData);
      }

      hasChanges.current = true;
      return { ...param.row, row };
    }

    function onSeqChanged(param: GridValueSetterParams) {
      let row: InvoiceItem = param.row;
      let tempGridData = [...gridData];  
      let index = tempGridData.findIndex(x => x.id === row.id);
      let duplicatedRowIndex = tempGridData.findIndex(x => x.seq == param.value);
      if (duplicatedRowIndex > -1)
      {
        //swap sequence no.
        tempGridData[duplicatedRowIndex].seq = tempGridData[index].seq;
      }

      tempGridData[index].seq = param.value;
      setGridData(tempGridData);

      hasChanges.current = true;
      return { ...param.row, row };
    }
        
    function validateSeqChanged(param: GridPreProcessEditCellProps) {
      let errMsg: string = "";

      errMsg = ValidateNumber(param.props.value.toString(), NumberTypes.INTEGER, true);

      if (errMsg !== "")
        showSnackBar(errMsg, "", "error");

      return { ...param.props, error: errMsg !== "" };
    }
    
    function validateQtyChanged(param: GridPreProcessEditCellProps) {
      let errMsg: string = "";

      errMsg = ValidateNumber(param.props.value.toString(), NumberTypes.INTEGER, true);

      if (errMsg !== "")
        showSnackBar(errMsg, "", "error");

      return { ...param.props, error: errMsg !== "" };
    }

    function validateNumberValueChanged(param: GridPreProcessEditCellProps) {
      let errMsg: string = "";

      errMsg = ValidateNumber(param.props.value.toString(), NumberTypes.FLOAT, true);

      if (errMsg !== "")
        showSnackBar(errMsg, "", "error");

      return { ...param.props, error: errMsg !== "" };
    }

    function validateEndUserChanged(param: GridPreProcessEditCellProps) {
      let invalid: boolean = false;
      let errMsg: string = "";
      if (props.endUsers.findIndex(x => x.endUserName.trim() === param.props.value || x.endUserEng.trim() === param.props.value) === -1 && param.props.value != "") {
        invalid = true;
        errMsg = "End user not found!";
      }

      if (invalid)
        showSnackBar(errMsg, "", "error");

      return { ...param.props, error: invalid };
    }

    function CopyValues() {
      let tempGridData = [...gridData];
      tempGridData.forEach(x => {
        if (x.endUser) {
          if (copyEndUserId == 0) {
            x.endUser = "";
            x.endUserID = 0;
          }
        }
        else {
          x.endUser = copyEndUser;
          x.endUserID = copyEndUserId;
        }
      })
      setGridData(tempGridData);
      hasChanges.current = true;
    }

    function CustomToolbar() {
      return (
        <GridToolbarContainer style={{ display: 'flex' }}>
          <Button variant="contained" size="small" color="secondary" style={{ margin: "2px" }} startIcon={<Add />} onClick={() => AddRow()}>Add</Button>
          <div style={{ width: 10 }}></div>
          <Button variant="contained" size="small" color="secondary" style={{ margin: "2px" }} startIcon={<Delete />} onClick={() => DeleteRows()}>Del</Button>
          <div style={{ width: 10 }}></div>
          <IconButton
              onMouseEnter={() => {
                if (selectedItem)
                {
                  if (selectedItem.poNo)
                  {
                    if (selectedItem.poNo.length > 0)
                      setShowPoNo('visible');
                  }
                }
              }}
              onMouseLeave={() => {
                setShowPoNo('hidden');
              }}
              sx={{visibility : selectedItem ? 'visible' : 'hidden'}}
              >
            <Info fontSize="large" />
          </IconButton>
          <div style={{ width: tinyScreen ? "calc(100% - 500px)" : (smallScreen ? "calc(100% - 650px)" : "calc(100% - 900px)") }}>
            <Box sx={{ width: 150, borderRadius: 1, border: 1, p: 1, 
                    color: "rgba(12,55,88, 0.95)", bgcolor: "rgba(118,185,237, 0.90)", 
                    visibility: showPoNo, justifyContent: "center" }} display="flex" >
                <Typography fontWeight="bold">
                  {selectedItem?.poNo}
                </Typography>
            </Box>
          </div>
          <IconButton
              onClick={(event) => {
                CopyValues();
              }}
            >
            <ContentCopy />
          </IconButton>
          <div style={{ width: 10 }}></div>
          <TextField
              variant="standard"
              label="End User"
              value={copyEndUser}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton size="small" sx={{ visibility: copyEndUser ? "visible" : "hidden" }}
                      onClick={() => { 
                          setCopyEndUser("");
                          setCopyEndUserId(0);
                        }
                      }
                    >
                      <Clear />
                    </IconButton>
                    <IconButton size="small"
                      onClick={() => { endUserListModalRef.current?.Initialise(); }
                      }
                    >
                      <Search />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
        </GridToolbarContainer>
      );
    }

    function AddRow() {
      singleModalRef.current?.Initialise();
    }

    function DeleteRows() {
      if (selectedData.current.length == 0)
      {
        return;
      }
      let tempGridData = [...gridData];
      selectedData.current.forEach(item => {
        let index = tempGridData.findIndex(x => x.lotNo === item.lotNo);
        if (index > -1) {
          tempGridData.splice(index, 1);
        }
      });
      let i = 1;
      tempGridData.forEach(x => {
        x.id = i;
        x.lotNo = i;
        i++
      })
      setGridData(tempGridData);
      let temp = model;
      if (temp) {
        temp.invoiceItems = tempGridData;
      }
      setModel(temp);
      setSelectionModel([])
      selectedData.current = [];
    }

    function AddCustomerAddress() {
      if (selectedCustomer)
        customerAddressModalRef.current?.Initialise(selectedCustomer.customerId);
    }

    function AddCustomerContactPerson() {
      if (selectedCustomer)
        customerContactPersonModalRef.current?.Initialise(selectedCustomer.customerId);
    }

    //Dialogs and snacks
    const hasChanges = React.useRef<boolean>(false);
    const [dialogOpen, setDialogOpen] = React.useState<boolean>(false);
    const [snackSettings, setSnackSettings] =
      React.useState<SnackBarMessageProps>({
        open: false,
        message: "",
        subMessage: "",
        severity: undefined,
        onClose: () => setSnackSettings({ open: false, message: "", subMessage: "", severity: undefined, onClose: () => {}})
      });

    function showSnackBar(message: string, subMessage: string, colour?: AlertColor) {
      setSnackSettings({
        open: true,
        message: message,
        subMessage: subMessage,
        severity: colour,
        onClose: () => setSnackSettings({ open: false, message: "", subMessage: "", severity: undefined, onClose: () => {}})
      });
    }


    useImperativeHandle(ref, () => ({
      Initialise(mode: OpenMode, invoice: Invoice, isProforma: boolean) {
        setOpen(true);
        setSelectedItem(null);
        setSaved(false);
        renewToken();

        hasChanges.current = false;
        setOpenMode(mode);
        setCopyEndUser("");
        setCopyEndUserId(0);
        setCurrency(invoice.currency);
        setNextMonthDisabled(isProforma || (mode === OpenMode.EDIT));
        let region = GetInvoiceRegion(invoice.invoiceNo);
        setRegion(region);
        if (isProforma)
          setProformaInvoicePrefix("PI" + region);

        setInvoiceRegions(props.regions.filter(function(x) {
          return defaultInvoiceRegions.indexOf(x.value) > -1;
        }));

        axios.all([
          axios.get<any[]>(`Api/V1/Bank`, {
              headers: {
                  'Content-Encoding': 'gzip'
              }
          }),
          axios.get<any[]>(`Api/V1/Bank/BankAccount/0`, {
              headers: {
                  'Content-Encoding': 'gzip'
              }
          }),
          axios.get<any[]>(`Api/V1/Branch`, {
            headers: {
              'Content-Encoding': 'gzip'
            }
          })
        ]).then(axios.spread((...responses) => {
          const bankResult: AxiosResponse<Bank[]> = responses[0];
          const bankAccountResult: AxiosResponse<BankAccount[]> = responses[1];
          const branchResult: AxiosResponse<BranchInfo[]> = responses[2];
          let bankName = "";

          setAllBanks(bankResult.data);
          setAllBankAccounts(bankAccountResult.data);
          if (region == "SS" || region == "TH")
          {
            let banksByRegion = bankResult.data.filter(x => x.region == region);
            setBanks(banksByRegion);
            if (banksByRegion.length > 0)
            {
              let bankId = banksByRegion.find(x => x.bankName == invoice.bankName)?.bankID ?? banksByRegion[0].bankID;
              bankName = banksByRegion.find(x => x.bankID == bankId)?.bankName ?? (region == "SS" ? defaultBankNameSS : defaultBankNameTH);
              setSelectedBankId(bankId);
              let bankAccountsByBank = bankAccountResult.data.filter(x => x.bankID == bankId);
              setBankAccounts(bankAccountsByBank);
              setSelectedBankAccountId(bankAccountsByBank.find(x => x.bankAccountNumber == invoice.bankAccount || x.bankAccountNumber.indexOf(invoice.currency) > -1)?.bankAccountID ?? 
                                      (bankId == 2 ? bankAccountsByBank[1].bankAccountID : bankAccountsByBank[0].bankAccountID));
            }
            else 
            {
              setBankAccounts(bankAccountResult.data);
            }
          }
          else
          {
            let banksByRegion = bankResult.data.filter(x => x.region != "SS" && x.region != "TH");
            setBanks(banksByRegion);
            if (banksByRegion.length > 0)
            {
              let bankId = banksByRegion.find(x => x.bankName == invoice.bankName)?.bankID ?? banksByRegion[0].bankID;
              bankName = banksByRegion.find(x => x.bankID == bankId)?.bankName ?? defaultBankName;
              setSelectedBankId(banksByRegion.find(x => x.bankName == invoice.bankName)?.bankID ?? banksByRegion[0].bankID);
              let bankAccountsByBank = bankAccountResult.data.filter(x => x.bankID == bankId);
              setBankAccounts(bankAccountsByBank);
              setSelectedBankAccountId(bankAccountsByBank.find(x => x.bankAccountNumber == invoice.bankAccount || x.bankAccountNumber.indexOf(invoice.currency) > -1)?.bankAccountID ?? 
                                      (bankId == 1 ? bankAccountsByBank[1].bankAccountID : bankAccountsByBank[0].bankAccountID));
            }
          }
          setBranchInfo(branchResult.data);
          
          FilterCustomersByLanguage([0]); //Always show customer names of any language
          
          if (mode === OpenMode.NEW)
          {
            setDisableRegionDropDown(false);
            setDisablePreviewButton(true);
            setInvoiceTotal(0);
          }
          else if (mode === OpenMode.EDIT)
          {
            setDisableRegionDropDown(true);
            setDisablePreviewButton(false);

            let total = 0.0;
            invoice.invoiceItems.forEach(i => {
              i.id = i.lotNo;
              total += i.euPrice * i.qty;
            });
            setInvoiceTotal(total);

            LoadCustomerInfo(invoice.customerID, invoice.custLangID, invoice.customerName, true);
          } 
          else if (mode === OpenMode.COPY)
          {
            setDisableRegionDropDown(false);
            setDisablePreviewButton(true);
            setSwitchPageOnClose(true);
    
            let total = 0.0;
            invoice.invoiceItems.forEach(i => {
              i.id = i.lotNo;
              total += i.euPrice * i.qty;
            });
            setInvoiceTotal(total);

            LoadCustomerInfo(invoice.customerID, invoice.custLangID, invoice.customerName, true);
          }

          let temp: any = { ...model };
          temp = invoice;
          if (invoice.isProforma && (mode === OpenMode.NEW))
            temp.invoiceNo = "";
          if (props.paymentTerms.findIndex(x => x.name === temp.paymentTerm) > -1)
            temp.paymentTerm = temp.paymentTerm;
          else
            temp.paymentTerm = "30 days after delivery";
          temp.mobile = "";  
          temp.email = "";
          temp.loginName = "";
          temp.bankName = bankName;
  
          setModel(temp);
  
          setGridData(invoice.invoiceItems)

          setLoading(false);
        })).catch((error) => {
          console.log(error);
          setBanks([]);
          setBankAccounts([]);
          setBranchInfo([]);
          setHasError(true);
          setLoading(false);
          showSnackBar(error.toString(), error?.response?.data?.errors[0], "error");
        })
    },
    }));

    function closeModal() {
      setDialogOpen(false);
      setOpen(false);
      props.onClose(false, model!);
    }

    function closeModalCheck(keepOpen: boolean) {
      if (hasChanges.current) {
        setDialogOpen(true);
      } else {
        setDialogOpen(false);
        setOpen(keepOpen);
        props.onClose(switchPageOnClose && saved, model!);
      }
    }

    function isSaveValid(showWarning: boolean) {
      let proceed = true;
      let warning = "";
      let noOfLines = 0;
      if (model) {
        if (model.invoiceItems)
        {
          let lotNos = model.invoiceItems.map(item => item.lotNo);
          if (HasDuplicates(lotNos)) {
            warning += "Duplicated \'No\' found in invoice items\r\n";
            noOfLines++;
            proceed = false;
          }
        }

        if (model.customerName === "" || model.customerID === 0) {
          warning += "Please select a customer\r\n"
          noOfLines++;
          proceed = false
        }

        if (model.staff === "" || model.staffID === 0) {
          warning += "Please select a staff\r\n"
          noOfLines++;
          proceed = false
        }

        if (!proceed && showWarning) {
          showSnackBar(warning, "", "warning");
        }
      }

      return proceed;
    }

    function Update(
      propertyName: string,
      propertyValue: any,
      validationRegex?: RegExp
    ) {
      let proceed = true;

      if (validationRegex !== undefined) {
        proceed = validationRegex.test(propertyValue);
      }

      if (proceed) {
        let temp: any = { ...model };

        if (temp[propertyName] != propertyValue)
        {
          hasChanges.current = true;
          temp[propertyName] = propertyValue ?? null;
          setModel(temp);
        }
      }
    }

    function CustomerChanged(newCustomer: any) {
      if (newCustomer) {
        let custId = newCustomer.value % 100000;
        let custLangId = Math.trunc(newCustomer.value / 100000);
        LoadCustomerInfo(custId, custLangId, newCustomer.name, false);
      }
    }

    function LoadCustomerInfo(customerId: number, custLangId: number, custName: string, isInit: boolean)
    {
      axios.get<Customer>('Api/V1/Customer/' + customerId.toString(), {
        headers: {
          'Content-Encoding': 'gzip'
        }
      })
        .then((result) => {
          if (result.data) 
          {
            setSelectedCustomer(result.data)

            if (!isInit)
            {
              hasChanges.current = true;
              let temp: any = { ...model };
              temp.customerID = customerId;
              temp.customerName = custName;
              temp.custLangID = custLangId;
              temp.attention = result.data.contactPerson;
              temp.phone = result.data.phone1;
              temp.fax = result.data.fax1;
              temp.shipAttn = result.data.contactPerson;
              temp.deliveryAddress = result.data.deliveryAddress;
              if (props.paymentTerms.findIndex(x => x.name === result.data.paymentTerm) > -1)
                temp.paymentTerm = result.data.paymentTerm;
              else
                temp.paymentTerm = defaultPaymentTerm;
  
              setModel(temp);
            }
          }
        },
          (error) => {
            console.log(error);
            showSnackBar(error.toString(), error?.response?.data?.errors[0], "error");
          }
        )
        .catch((error) => {
          console.log(error);
          showSnackBar(error.toString(), error?.response?.data?.errors[0], "error");
        });        
    }

    function LanguageChanged(langId: number) {
      hasChanges.current = true;
      let custLangIds = GetCustLangIdsByLanguageId(langId);
      let temp: any = { ...model };
      let availableCustomerLanguageIds: number[] = [];

      for (var i = 1; i <= 3; i++) {
        let index = props.customers.findIndex(s => s.value === ((temp.customerID ?? 1) + i * 100000).toString());
        if (index > 0)
        {
          availableCustomerLanguageIds.push(i);
        }
      }

      let commonLangIds: number[] = custLangIds.filter(function(id) {
        return availableCustomerLanguageIds.indexOf(id) > -1;
      });

      if (commonLangIds.length == 0)
      {
        commonLangIds = availableCustomerLanguageIds;
      }

      let originalId = commonLangIds.find(x => x == model?.custLangID) ?? commonLangIds[0];
      temp.custLangID = originalId;
      temp.languageID = langId;
      switch(langId)
      {
        case 1:
          temp.invoiceItems.forEach((x: InvoiceItem) => {
            x.productDesc = x.nameEng ?? "";
          });
          break;
        case 2:
          temp.invoiceItems.forEach((x: InvoiceItem) => {
            x.productDesc = x.nameJpn ?? "";
          });
          break;
        case 3:
          temp.invoiceItems.forEach((x: InvoiceItem) => {
            x.productDesc = x.nameChi ?? "";
          });
          break;
        case 4:
          temp.invoiceItems.forEach((x: InvoiceItem) => {
            x.productDesc = ((x.nameEng ?? "") + "  " + (x.nameChi ?? "")).slice(0,80);
          });
          break;
        case 5:
          temp.invoiceItems.forEach((x: InvoiceItem) => {
            x.productDesc = ((x.nameEng ?? "") + "  " + (x.nameJpn ?? "")).slice(0,80);
          });
          break;
        case 6:
          temp.invoiceItems.forEach((x: InvoiceItem) => {
            x.productDesc = ((x.nameChi ?? "") + "  " + (x.nameJpn ?? "")).slice(0,80);
          });
          break;
      }
      setModel(temp);

      FilterCustomersByLanguage([0])
    }

    function GetBankIdByName(bankName: string) {
      return banks.find(x => x.bankName == bankName)?.bankID ?? 1;
    }

    function FilterCustomersByLanguage(langIds: number[]) {
      let temp: DropDownComboOption[] = props.customers;
      let result: DropDownComboOption[] = [];
      if (langIds.findIndex( x => x === 0) > -1)
      {
        setFilteredCustomers(props.customers);
      } 
      else
      {
        langIds.forEach((id) => {
          result = result.concat(Object.values(temp).filter(c => Math.trunc(parseInt(c.value) / 100000) === id));
        });
        setFilteredCustomers(result);
      }
    }

    function RegionChanged(region: string) {
      hasChanges.current = true;

      if (model?.isProforma)
      {
        setProformaInvoicePrefix("PI" + region);
      }
      else
      {
        axios.get<any[]>(`Api/V1/Branch`, {
          headers: {
            'Content-Encoding': 'gzip'
          }
        })
          .then((result) => {
            setBranchInfo(result.data);
  
            let branchSelected: BranchInfo | undefined = result.data.find(b => b.region === region);
            setRegion(region);
            if (branchSelected)
            {
              let temp: any = { ...model };
              let newInvoiceNo: string = "";
        
              let monthPart: string;
              if (nextMonthChecked)
              {
                if ((new Date().getMonth())===11)
                  monthPart = (new Date().getFullYear() + 1) + "/01";
                else
                  monthPart = (new Date().getFullYear()) + "/" + Pad(new Date().getMonth() + 2, 2);
              }
              else
                monthPart = (new Date().getFullYear()) + "/" + Pad(new Date().getMonth() + 1, 2);

              let invoiceNumber = branchSelected.invoiceNo;
              if (branchSelected.invoiceMonth != new Date().getMonth() + 1)
              {
                invoiceNumber = branchSelected.nextMonthInvoiceNo;
              }
              newInvoiceNo = "ME" + branchSelected.region + monthPart + Pad(nextMonthChecked ? branchSelected.nextMonthInvoiceNo : invoiceNumber, 3);
      
              temp["invoiceNo"] = newInvoiceNo;

              let bankName = "";
              if (branchSelected.region == "SS" || branchSelected.region == "TH")
              {
                let banksByRegion = allBanks.filter(x => x.region == region);
                setBanks(banksByRegion);
                if (banksByRegion.length > 0)
                {
                  let bankId = banksByRegion[0].bankID;
                  bankName = banksByRegion.find(x => x.bankID == bankId)?.bankName ?? (region == "SS" ? defaultBankNameSS : defaultBankNameTH);
                  setSelectedBankId(bankId);
                  let bankAccountsByBank = allBankAccounts.filter(x => x.bankID == bankId);
                  setBankAccounts(bankAccountsByBank);
                  setSelectedBankAccountId(bankId == 2 ? bankAccountsByBank[1].bankAccountID : bankAccountsByBank[0].bankAccountID);
                }
                else 
                {
                  setBankAccounts(allBankAccounts);
                }
              }
              else
              {
                let banksByRegion = allBanks.filter(x => x.region != "SS" && x.region != "TH");
                setBanks(banksByRegion);
                if (banksByRegion.length > 0)
                {
                  let bankId = banksByRegion[0].bankID;
                  bankName = banksByRegion.find(x => x.bankID == bankId)?.bankName ?? defaultBankName;
                  setSelectedBankId(bankId);
                  let bankAccountsByBank = allBankAccounts.filter(x => x.bankID == bankId);
                  setBankAccounts(bankAccountsByBank);
                  setSelectedBankAccountId(bankId == 1 ? bankAccountsByBank[1].bankAccountID : bankAccountsByBank[0].bankAccountID);
                }
              }
              temp["bankName"] = bankName;
              temp["bankAccount"] = allBankAccounts.find(x => x.bankAccountID == selectedBankAccountId)?.bankAccountNumber;
              setModel(temp);
            }
          },
            (error) => {
              setBranchInfo([]);
              console.log(error);
              showSnackBar(error.toString(), error?.response?.data?.errors[0], "error");
            }
          )
          .catch((error) => {
            console.log(error);
            showSnackBar(error.toString(), error?.response?.data?.errors[0], "error");
          });
      }
    }

    function InvoiceNoChanged(value: string) {
      let temp: any = { ...model };
      if (temp)
      {
        if (temp["isProforma"])
        {
          hasChanges.current = true;
          temp["invoiceNo"] = value;
          setModel(temp);
        }
      }
    }

    function NextMonthChanged(checked: boolean) {
      hasChanges.current = true;
      setNextMonthChecked(!nextMonthChecked);
      let temp: any = { ...model };
      temp["invoiceNo"] = getInvoiceNo(checked);
      setModel(temp);
    }

    function getInvoiceNo(nextMonthChecked: boolean) {
      let branchSelected: BranchInfo | undefined = branchInfo.find(b => b.region === region);
      let newInvoiceNo: string = "";

      let monthPart: string;
      if (nextMonthChecked)
      {
        if ((new Date().getMonth())===11)
          monthPart = (new Date().getFullYear() + 1) + "/01";
        else
          monthPart = (new Date().getFullYear()) + "/" + Pad(new Date().getMonth() + 2, 2);
      }
      else
        monthPart = (new Date().getFullYear()) + "/" + Pad(new Date().getMonth() + 1, 2);

      if (branchSelected)
        newInvoiceNo = "ME" + branchSelected.region + monthPart + Pad(nextMonthChecked ? branchSelected.nextMonthInvoiceNo : branchSelected.invoiceNo, 3);

      return newInvoiceNo;
    }

    function CurrencyChanged(ccy: string) {
      hasChanges.current = true;
      setCurrency(ccy);
      let temp: any = { ...model };
      let exRate = props.currencies.find(c => c.name === ccy)?.value;
      temp["currency"] = ccy;
      temp["exRate"] = Number(exRate);
      setModel(temp);
    }

    function ExRateChanged(exrate: string) {
      hasChanges.current = true;

      let msg = ValidateNumber(exrate, NumberTypes.FLOAT, true);
      if (msg === "")
      {
        let temp: any = { ...model };
        temp["exRate"] = exrate;
        setModel(temp);
      }
    }

    function SaveChanges(
      event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
      close: boolean
    ) {
      if (isSaveValid(true)) {
        event.preventDefault();
        event.stopPropagation();

        let m = model;
        if (m)
        {
          if (m.isProforma && (openMode === OpenMode.NEW || openMode === OpenMode.COPY))
          {
            m.invoiceNo = proformaInvoicePrefix + m.invoiceNo;
          }
          m.invoiceItems = gridData;
          m.deliveryContact = m.deliveryContact == null ? "" : m.deliveryContact;
          m.deliveryTo = m.deliveryTo == null ? "" : m.deliveryTo;
          m.deliveryPhone = m.deliveryPhone == null ? "" : m.deliveryPhone;
          m.deliveryFax = m.deliveryFax == null ? "" : m.deliveryFax;
          m.packingListPONo = m.packingListPONo == null ? "" : m.packingListPONo;
          m.plRemark1 = m.plRemark1 == null ? "" : m.plRemark1;
          m.plRemark2 = m.plRemark2 == null ? "" : m.plRemark2;
          m.plRemark3 = m.plRemark3 == null ? "" : m.plRemark3;
          m.updatedBy = "";
          m.bankAccount = bankAccount ?? "";
          m.bankAddress = bankAddress ?? "";
          m.createDate = moment(m.createDate).format();
          let maxSeq = Math.max(...m.invoiceItems.map(item => {return item.seq ?? 1;}));
          let i = 1;
          m.invoiceItems.forEach(item => {
            item.lotNo = item.seq ?? maxSeq + i;
            i++;
          });
          setModel(m);
        }
  
        if (openMode === OpenMode.EDIT)
        {
          axios.put<Invoice>('Api/V1/Invoice/', m).then(
            (result) => {
              if (result.data.invoiceItems?.length > 0)
              {
                result.data.invoiceItems.forEach(i => {
                  i.id = i.lotNo;
                });
  
                setGridData(result.data.invoiceItems)
              }              
  
              let temp: any = { ...model };
              temp = result.data;
              temp.mobile = ""; //mobile cannot be null when save  
              temp.email = ""; //email cannot be null when save
              temp.loginName = ""; //loginName cannot be null when save
              setModel(temp);
  
              showSnackBar("Invoice saved successfully.", "", "success");
              hasChanges.current = false;
              setOpen(!close);
              setDialogOpen(false);
            },
            (error) => {
              showSnackBar(error.toString(), error?.response?.data?.errors[0], "error");
            }
          );
        } 
        else
        {
          axios.post<Invoice>('Api/V1/Invoice/', m).then(
            (result) => {
              if (result.data.invoiceItems?.length > 0)
              {
                result.data.invoiceItems.forEach(i => {
                  i.id = i.lotNo;
                });
  
                setGridData(result.data.invoiceItems)
              }
  
              let temp: any = { ...model };
              temp = result.data;
              temp.mobile = ""; //mobile cannot be null when save  
              temp.email = ""; //email cannot be null when save
              temp.loginName = ""; //loginName cannot be null when save
              temp.address = ""; //address cannot be null when save
              setModel(temp);
  
              showSnackBar("Invoice created successfully.", "", "success");
              hasChanges.current = false;
              setSaved(true);
              setDisableRegionDropDown(true);
              setDisablePreviewButton(false);
              setOpenMode(OpenMode.EDIT);
              setOpen(!close);
              setDialogOpen(false);
            },
            (error) => {
              showSnackBar(error.toString(), error?.response?.data?.errors[0] ?? "", "error");
            }
          );
        }
      }
    }

    function Preview(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
      let m = model;
       if (m)
         viewerModalRef.current?.Initialise(m.invoiceNo, showEndUser);
    }

    function PopulateSelectedEndUser(hasSelection: boolean, endUserListItem: React.MutableRefObject<EndUserListItem>)
    {
      if (!hasSelection)
        return;

      setCopyEndUser(endUserListItem.current.endUserName);
      setCopyEndUserId(endUserListItem.current.endUserId);
    }

    function PopulateSelectedProducts(hasSelection: boolean, productItems: React.MutableRefObject<ProductListItem[]>)
    {
      if (!hasSelection)
        return;

      let newQoutationItems: InvoiceItem[] = [];
      let m = model;
      if (m) {
        let lotNos: number[] | undefined = m?.invoiceItems?.map(i => i.lotNo);

        let maxLotNo: number = 1;
        if (lotNos && lotNos.length>0)
        {
          maxLotNo = Math.max(...lotNos) + 1;
        }

        let total = 0.0;
        productItems.current.forEach((item) => {
          let calculatedPrice = (item.price ?? 0) * 0.7 * (m?.exRate ?? 0);
          let productDescription: string = "";
          total += calculatedPrice  * (item.minOrderQty ?? 1);
          switch (m?.languageID ?? 1) {
            case 1:
              productDescription = item.nameEng ?? (item.nameChi ?? (item.nameJpn ?? ""));
              break;
            case 2:
              productDescription = item.nameJpn ?? (item.nameChi ?? (item.nameEng ?? ""));
              break;
            case 3:
              productDescription = item.nameChi ?? (item.nameJpn ?? (item.nameEng ?? ""));
              break;
            case 4:
              productDescription = (item.nameEng ?? "") + " " + (item.nameChi ?? "");
              break;
            case 5:
              productDescription = (item.nameEng ?? "") + " " + (item.nameJpn ?? "");
              break;
          }

          const invoiceItem: InvoiceItem = {
            id: maxLotNo,
            invoiceNo: m?.invoiceNo ?? "",
            lotNo: maxLotNo,
            productID: item.productID,
            orderQty: item.minOrderQty ?? 1,
            euPrice: calculatedPrice,
            qty: item.osQty > 0 ? item.osQty : (item.minOrderQty ?? 1),
            osQty: item.osQty > 0 ? item.osQty : (item.minOrderQty ?? 1),
            clientPO: item.customerPO,
            poNo: item.osQty > 0 ? item.poNo : '',
            poLotNo: item.osQty > 0 ? item.poLotNo : 0,
            productDesc: productDescription,
            nameJpn: item.nameJpn,
            nameChi: item.nameChi,
            nameEng: item.nameEng,
            description: item.description,
            productCode: item.productCode,
            model: item.model,
            price: item.price,
            netWeight: item.netWeight,
            minOrderQty: item.minOrderQty,
            endUser: item.endUser,
            cartonNo: "",
            customerPartNo: "",
            unit: item.unit,
            partNo: "",
            serialNo: ""
          };
          newQoutationItems.push(invoiceItem);
          maxLotNo++;
        }
        )

        setInvoiceTotal(total);

        let tempData = [...gridData, ...newQoutationItems];
        setGridData(tempData);

        m.invoiceItems = tempData;
        setModel(m);
        hasChanges.current = true;
      }

    }

    function FillCustomerAddress(hasSelection: boolean, customerAddressItem: React.MutableRefObject<CustomerAddressItem>)
    {
      if (!hasSelection)
        return;

        Update("deliveryAddress", customerAddressItem.current.address);
    }

    function FillCustomerContactPerson(hasSelection: boolean, customerContactPersonItem: React.MutableRefObject<CustomerContactPersonItem>)
    {
      if (!hasSelection)
        return;

        Update("attention", customerContactPersonItem.current.contactPerson);
    }

    return (
      <div>
        <Modal open={open} onClose={() => closeModalCheck(true)}>
          <div className={style.ModalMain}>
            {model && !loading ? (
              <div className={style.ModalBody}>
                <Title pageTitle="Invoice" />
                <div className={style.ModalContent}>
                  <div className={style.ModalFields}>
                    <CustomDropDown3 className={style.ModalContentField} 
                      dropDownBoxWidth={tinyScreen ? "70px" : (smallScreen ? "85px" : "100px")}
                      firstTextBoxWidth={tinyScreen ? "calc(100% - 158px)" : (smallScreen ? "calc(100% - 200px)" : "calc(100% - 242px)")}
                      firstTextBoxMinWidth={tinyScreen ? "116px" : (smallScreen ? "201px" : "306px")}
                      dropDownBoxId="region-dropdown" dropDownBoxLabel="Region" dropDownBoxDisabled={disableRegionDropDown} 
                      firstTextBoxLabel="Invoice No" firstTextBoxName="txtInvoiceNo" 
                      dropDownBoxValue={region} dropDownBoxOptions={invoiceRegions}
                      firstTextBoxValue={model.invoiceNo} 
                      firstTextBoxReadOnly={!(model.isProforma && (openMode == OpenMode.NEW || openMode == OpenMode.COPY))}
                      firstTextBoxTextLength={11}
                      checked={nextMonthChecked}
                      onSelectionChanged={RegionChanged}
                      onTextBoxValueChanged={InvoiceNoChanged}
                      onCheckBoxValueChanged={NextMonthChanged}
                      checkBoxDisabled={nextMonthDisabled} />
                    <div className={style.ModalContentField}
                      style={{ minWidth: tinyScreen ? "274px" : (smallScreen ? "374px" : "494px") }}
                    >
                      <div className={style.ModalInnerContentFieldOneThirdWidthLeft}
                        style={{ minWidth: tinyScreen ? "110px" : (smallScreen ? "140px" : "170px") }}
                      >
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                          <DatePicker
                            key="invoiceDate"
                            label="Invoice Date"
                            inputFormat="yyyy/MM/dd"
                            mask="____/__/__"
                            value={Date.parse(model.createDate)}
                            onChange={(newValue) => Update("createDate", moment(newValue).format('YYYY/MM/DD'))}
                            renderInput={(params) => <TextField {...params} sx={{ width: '100%' }} size="small" />}
                          />
                        </LocalizationProvider>
                      </div>
                      <Autocomplete className={style.ModalInnerContentFieldTwoThirdWidthRight}
                        limitTags={2}
                        onChange={(e, selected) => {
                          let temp: any = { ...model };
                          temp.staffID = Number(selected?.value);
                          temp.staff = selected?.name;
                          setModel(temp);
                        }}
                        options={props.sales}
                        getOptionLabel={(option: DropDownComboOption) => option.name}
                        renderOption={(props, option) => {
                          return (
                            <li {...props} key={option.value}>
                              {option.name}
                            </li>
                          );
                        }}
                        value={props.sales.find(s => s.value === model.staffID?.toString()) || null}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="outlined"
                            label={"Sales"}
                            size="small"
                            fullWidth                            
                          />
                        )}
                      />
                    </div>
                    <Autocomplete className={style.ModalContentField}
                        limitTags={2}
                        onChange={(e, selected) => CustomerChanged(selected)}
                        options={filteredCustomers}
                        getOptionLabel={(option: DropDownComboOption) => option.name}
                        renderOption={(props, option) => {
                          return (
                            <li {...props} key={option.value}>
                              {option.name}
                            </li>
                          );
                        }}
                        value={filteredCustomers.find(s => s.value === (model.customerID + model.custLangID * 100000).toString()) || null}
                        style={{ minWidth: tinyScreen ? "274px" : (smallScreen ? "374px" : "494px") }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="outlined"
                            label={"Customer"}
                            size="small"
                            fullWidth
                          />
                        )}
                      />
                      <TextField className={style.ModalContentField} 
                        value={model.attention}
                        label="Attention"
                        onChange={(e) => Update("attention", e.target.value)}
                        style={{ minWidth: tinyScreen ? "274px" : (smallScreen ? "374px" : "494px") }}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton onClick={(e) => AddCustomerContactPerson()}><Add /></IconButton>
                            </InputAdornment>
                          ),
                        }}
                        size="small"
                        fullWidth
                      />   
                  </div>
                  <div className={style.ModalFields}>
                    <div className={style.ModalContentField}
                      style={{ minWidth: tinyScreen ? "274px" : (smallScreen ? "374px" : "494px") }}
                    >
                      <TextField className={style.ModalInnerContentFieldOneThirdWidthLeft}
                        value={model.languageID}
                        onChange={(e) => LanguageChanged(parseInt(e.target.value))}
                        style={{ minWidth: tinyScreen ? "80px" : (smallScreen ? "110px" : "140px") }}
                        select
                        label="Language"
                        size="small"
                        fullWidth
                      >
                        {Languages.map((item) => (
                          <MenuItem key={item.id} value={item.id}>{item.value}</MenuItem>
                        ))}
                      </TextField>
                      <CustomDropDown1 className={style.ModalInnerContentFieldTwoThirdWidthRight} 
                        dropDownBoxWidth={tinyScreen ? "70px" : (smallScreen ? "85px" : "100px")} 
                        firstTextBoxWidth={tinyScreen ? "calc(100% - 70px)" : (smallScreen ? "calc(100% - 85px)" : "calc(100% - 100px)")} 
                        firstTextBoxMinWidth={tinyScreen ? "60px" : (smallScreen ? "75px" : "90px")}
                        dropDownBoxId="currency-dropdown" dropDownBoxLabel="CCY" dropDownBoxDisabled={false} 
                        firstTextBoxLabel="Ex. Rate" firstTextBoxName="txtExRate"
                        dropDownBoxValue={currency} dropDownBoxOptions={props.currencies}
                        firstTextBoxValue={model.exRate.toString()} firstTextBoxReadOnly={false}
                        type="number"
                        onSelectionChanged={CurrencyChanged}
                        onTextBoxValueChanged={ExRateChanged} />
                    </div>
                    <div className={style.ModalContentField}
                      style={{ minWidth: tinyScreen ? "274px" : (smallScreen ? "374px" : "494px") }}
                    >
                      <TextField className={style.ModalInnerContentFieldLeft}
                        value={model.arrivalDate}
                        label="Arrival Date"
                        onChange={(e) => Update("arrivalDate", e.target.value.slice(0,26))}
                        size="small"
                        fullWidth
                      />
                      <TextField className={style.ModalInnerContentFieldRight}
                        value={model.shipAttn}
                        label="Ship Attention"
                        onChange={(e) => Update("shipAttn", e.target.value.slice(0,30))}
                        size="small"
                        fullWidth
                      />
                    </div>
                    <TextField className={style.ModalContentField} 
                      value={model.deliveryAddress}
                      label="Ship Address"
                      onChange={(e) => Update("deliveryAddress", e.target.value.slice(0,250))}
                      style={{ minWidth: tinyScreen ? "274px" : (smallScreen ? "374px" : "494px") }}
                      multiline
                      rows={GetNoOfLines(model.deliveryAddress)}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton onClick={(e) => AddCustomerAddress()}><Add /></IconButton>
                          </InputAdornment>
                        ),
                      }}
                      size="small"
                      fullWidth
                    />
                    <div className={style.ModalContentField}
                      style={{ minWidth: tinyScreen ? "274px" : (smallScreen ? "374px" : "494px") }}
                    >
                      <TextField className={style.ModalInnerContentFieldLeft}
                        value={model.phone}
                        label="Telephone"
                        onChange={(e) => Update("phone", e.target.value.slice(0,25))}
                        size="small"
                        fullWidth
                      />
                      <TextField className={style.ModalInnerContentFieldRight}
                        value={model.fax}
                        label="Fax"
                        onChange={(e) => Update("fax", e.target.value.slice(0,25))}
                        size="small"
                        fullWidth
                      />
                    </div>
                  </div>
                  <div className={style.PageContent} style={{ minHeight: "290px" }}>
                    <DataGridPro
                      headerHeight={tinyScreen ? 28 : (smallScreen ? 32 : 36)}
                      rowHeight={tinyScreen ? 24 : (smallScreen ? 28 : 32)}
                      getRowId={(row) => row.id}
                      rows={gridData}
                      columns={columns}
                      pageSize={searchData.pageSize}
                      onPageSizeChange={(pageSize) => setSearchData({ ...searchData, pageSize: pageSize })}
                      pagination
                      rowsPerPageOptions={[10, 20, 40]}
                      loading={loading}
                      checkboxSelection
                      components={{
                        Toolbar: CustomToolbar,
                        Footer: CustomTablePagination
                      }}
                      componentsProps={{
                        footer: { rowsPerPageOptions: [10, 20, 40] }
                      }}
                      selectionModel = {selectionModel}
                      onSelectionModelChange={(selections) => {
                        setSelectionModel(selections)
                        const ids = new Set(selections);
                        const selectedRows = gridData.filter((row) => ids.has(row.lotNo));
                        selectedData.current = selectedRows;
                      }}
                      disableSelectionOnClick={true}
                      onRowClick = {(param) => {
                        setSelectedItem(param.row);
                      }}
                    />
                  </div>
                  <div className={style.ModalFields}>
                    <div className={style.ModalContentField}
                      style={{ minWidth: tinyScreen ? "274px" : (smallScreen ? "374px" : "494px") }}
                    >
                      <NumberFormat className={`${style.ModalInnerContentFieldOneThirdWidthLeft}`}
                        customInput={TextField}
                        value={invoiceTotal}
                        label="Invoice Total"
                        inputProps={{ readOnly: true }}
                        decimalScale={currency=='JPY' ? 0 : 2}
                        thousandSeparator
                        size="small"
                        fullWidth
                        />
                      <NumberFormat className={`${style.ModalInnerContentFieldOneThirdWidthMiddle}`} 
                        customInput={TextField}
                        value={model.lessAmount}
                        label="Less"
                        error={lessAmountErrorText !== ""}
                        helperText={lessAmountErrorText}
                        decimalScale={currency=='JPY' ? 0 : 2}
                        thousandSeparator
                        onValueChange={(e) => {
                          if (e.value !== "")
                          {
                            let msg = ValidateNumber(e.value, NumberTypes.FLOAT, true);
                            setLessAmountErrorText(msg);
                            if (msg === "")
                              Update("lessAmount", e.value);
                          }
                        }}
                        size="small"
                        fullWidth
                      />
                      <NumberFormat className={`${style.ModalInnerContentFieldOneThirdWidthRight}`} 
                        customInput={TextField}
                        value={model.lessPercent}
                        label="Less %"
                        error={lessPercentErrorText !== ""}
                        helperText={lessPercentErrorText}
                        decimalScale={1}
                        thousandSeparator
                        onValueChange={(e) => {
                          if (e.value !== "")
                          {
                            let msg = ValidateNumber(e.value, NumberTypes.FLOAT, true);
                            setLessPercentErrorText(msg);
                            if (msg === "")
                              Update("lessPercent", e.value);
                          }
                        }}
                        size="small"
                        fullWidth
                      />
                    </div>
                    <div className={style.ModalContentField}
                      style={{ minWidth: tinyScreen ? "274px" : (smallScreen ? "374px" : "494px") }}
                    >
                      <TextField className={style.ModalInnerContentFieldLeft}
                        value={model.carton}
                        label="Carton Total"
                        onChange={(e) => Update("carton", e.target.value.slice(0,20))}
                        size="small"
                        fullWidth
                      />
                      <TextField className={style.ModalInnerContentFieldRight}
                        value={model.reportTotal}
                        label="Parts Total"
                        onChange={(e) => Update("reportTotal", e.target.value.slice(0,50))}
                        size="small"
                        fullWidth
                      />
                    </div>
                    <TextField className={style.ModalContentField}
                        value={model.deliveryBy}
                        label="Ship By"
                        onChange={(e) => Update("deliveryBy", e.target.value.slice(0,80))}
                        style={{ minWidth: tinyScreen ? "274px" : (smallScreen ? "374px" : "494px") }}
                        rows={GetNoOfLines(model.deliveryBy)}
                        multiline
                        size="small"
                        fullWidth
                    />
                    <TextField className={style.ModalContentField}
                      id="payment-term"
                      style={{ minWidth: tinyScreen ? "274px" : (smallScreen ? "374px" : "494px") }}
                      value={model.paymentTerm}
                      onChange={(e) => Update("paymentTerm", e.target.value)}
                      select
                      label="Payment Term"
                      size="small"
                      fullWidth
                    >
                      {props.paymentTerms.map((item) => (
                        <MenuItem key={item.value} value={item.value}>
                          {item.value}
                        </MenuItem>
                      ))}
                    </TextField>
                  </div>
                  <div className={style.ModalFields}>
                    <TextField className={style.ModalContentField}
                      id="bank"
                      style={{ minWidth: tinyScreen ? "274px" : (smallScreen ? "374px" : "494px") }}
                      value={model.bankName}
                      onChange={(e) => {
                        setSelectedBankId(GetBankIdByName(e.target.value));
                        let bankAccountsByBank = allBankAccounts.filter(x => x.bankID == getBankId(e.target.value));
                        setBankAccounts(bankAccountsByBank);
                        let selectedBankAccount = bankAccountsByBank.find(x => x.bankID == getBankId(e.target.value));
                        setSelectedBankAccountId(selectedBankAccount?.bankAccountID ?? 0);

                        let temp: any = { ...model };
                        temp["bankName"] = e.target.value ?? null;
                        temp["bankAccount"] = selectedBankAccount?.bankAccountNumber ?? null;
                        temp["bankAddress"] = banks.find(x => x.bankID == getBankId(e.target.value))?.bankAddress;
                        setModel(temp);
                      }}
                      select
                      label="Bank Name"
                      size="small"
                      fullWidth
                    >
                      {banks.map((item) => (
                        <MenuItem key={item.bankID} value={item.bankName}>
                          {item.bankName}
                        </MenuItem>
                      ))}
                    </TextField>
                    <TextField className={style.ModalContentField}
                      id="bank-account"
                      style={{ minWidth: tinyScreen ? "274px" : (smallScreen ? "374px" : "494px") }}
                      value={bankAccount}
                      onChange={(e) => {
                        setSelectedBankAccountId(getBankAccountId(e.target.value));
                        Update("bankAccount", e.target.value);
                      }}
                      select
                      label="Bank Account"
                      size="small"
                      fullWidth
                    >
                      {accountsByBank.map((item) => (
                        <MenuItem key={item.bankAccountID} value={item.bankAccountNumber}>
                          {item.bankAccountNumber}
                        </MenuItem>
                      ))}
                    </TextField>
                    <TextField className={style.ModalContentField}
                      value={bankAddress}
                      label="Bank Address"
                      style={{ minWidth: tinyScreen ? "274px" : (smallScreen ? "374px" : "494px") }}
                      multiline={true}
                      rows={2}
                      size="small"
                      fullWidth
                    />
                    <TextField className={style.ModalContentField}
                      value={model.remark}
                      label="Remark"
                      onChange={(e) => Update("remark", e.target.value.slice(0,200))}
                      style={{ minWidth: tinyScreen ? "274px" : (smallScreen ? "374px" : "494px") }}
                      multiline={true}
                      rows={2}
                      size="small"
                      fullWidth
                    />
                  </div>
                </div>

                <div className={style.ModalFooter}>
                  <FormControlLabel
                    control={
                      <Checkbox checked={showEndUser} onChange={(e) => setShowEndUser(e.target.checked)} />
                    }
                    label="Print End User"
                  />
                  <Button
                    variant="contained"
                    color="secondary"
                    className={style.margin}
                    onClick={(e) => SaveChanges(e, false)}
                  >
                    Save
                  </Button>
                  <Button
                    variant="contained"
                    color="secondary"
                    className={style.margin}
                    disabled={disablePreviewButton}
                    onClick={(e) => Preview(e)}
                  >
                    Preview
                  </Button>
                  <Button
                    variant="contained"
                    className={style.margin}
                    onClick={(e) => closeModalCheck(false)}
                  >
                    Close
                  </Button>
                </div>

              </div>
            ) : (
              <div style={{ textAlign: "center" }}>
                <CircularProgress color="primary" />
              </div>
            )}
          </div>
        </Modal>

        <SnackBarMessage {...snackSettings} />

        <GeneralDialog
          title={"Save Changes?"}
          message={
            "Changes have been made, did you want to save before closing?"
          }
          open={dialogOpen}
          options={[
            {
              text: "Save",
              action: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => SaveChanges(event, true),
              color: "secondary",
              variant: "contained",
            },
            {
              text: "No",
              action: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => closeModal(),
              color: "primary",
              variant: "contained",
            },
          ]}
        />

        <ProductList
          ref={singleModalRef}
          onClose={(hasSelection: boolean, productItems: React.MutableRefObject<ProductListItem[]>) => PopulateSelectedProducts(hasSelection, productItems)}
        />

        <EndUserList
          ref={endUserListModalRef}
          onClose={(hasSelection: boolean, endUserListItem: React.MutableRefObject<EndUserListItem>) => PopulateSelectedEndUser(hasSelection, endUserListItem)} 
          customers={props.customers} 
          regions={props.regions} />

        <InvoiceViewer ref={viewerModalRef} onClose={()=>{}}/>

        <CustomerAddress 
          ref={customerAddressModalRef} 
          onClose={(hasSelection: boolean, customerAddressItem: React.MutableRefObject<CustomerAddressItem>) => FillCustomerAddress(hasSelection, customerAddressItem)} />

        <CustomerContactPerson 
          ref={customerContactPersonModalRef} 
          onClose={(hasSelection: boolean, customerContactPersonItem: React.MutableRefObject<CustomerContactPersonItem>) => FillCustomerContactPerson(hasSelection, customerContactPersonItem)} />

      </div>
    );


  }

);
